import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/',
    name: 'Index',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Index.vue')
    }
  },

  {
    path: '/register',
    name: 'Register',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Register.vue')
    }
  },

 

  {
    path: '/course-index',
    name: 'CourseIndex',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/CourseIndex.vue')
    }
  },
  {
    path: '/reporte-avance',
    name: 'ReporteAvance',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/ReporteAvance.vue')
    }
  },
  {
    path: '/home-teacher',
    name: 'HomeTeacher',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/HomeTeacher.vue')
    }
  },
  {
    path: '/admin-groups',
    name: 'AdminGroups',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/AdminGroups.vue')
    }
  },
  {
    path: '/group-info',
    name: 'GroupInfo',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/GroupInfo.vue')
    }
  },
  {
    path: '/ebooks',
    name: 'Ebooks',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Ebooks.vue')
    }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/ForgotPassword.vue')
    }
  },
  {
    path: '/projects',
    name: 'Projects',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Projects.vue')
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Profile.vue')
    }
  },
  {
    path: '/referredUsers',
    name: 'ReferredUsers',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/ReferredUsers.vue')
    }
  },
  




  {
    path: '/adobe',
    name: 'Adobe',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Landing/adobe.vue')
    }
  }, 
  {
    path: '/autodesk',
    name: 'Autodesk',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Landing/autodesk.vue')
    }
  },
  {
    path: '/its',
    name: 'Its',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Landing/its.vue')
    }
  },   
  {
    path: '/mos',
    name: 'Mos',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Landing/mos.vue')
    }
  },
  {
    path: '/esb',
    name: 'Esb',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Landing/esb.vue')
    }
  },
  {
    path: '/ic3',
    name: 'IC3',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Landing/ic3.vue')
    }
  },
  {
    path: '/swift',
    name: 'Swift',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Landing/swift.vue')
    }
  },  
  {
    path: '/pmi',
    name: 'pmi',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Landing/pmi.vue')
    }
  },  
  {
    path: '/csb',
    name: 'csb',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Landing/csb.vue')
    }
  },  
  {
    path: '/unity',
    name: 'unity',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Landing/unity.vue')
    }
  },  
  {
    path: '/cisco',
    name: 'cisco',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Landing/cisco.vue')
    }
  },  
  {
    path: '/mce',
    name: 'mce',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Landing/mce.vue')
    }
  },  
  {
    path: '/thankyou',
    name: 'thankyou',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Landing/thankyou.vue')
    }
  },






  {
    path: '/productos',
    name: 'Productos',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Store/Productos.vue')
    }
  },
  {
    path: '/detalle-producto/:id',
    name: 'DetalleProducto',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Store/DetalleProducto.vue')
    }
  },
  {
    path: '/carrito',
    name: 'Carrito',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Store/Carrito.vue')
    }
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Store/Checkout.vue')
    }
  },
  {
    path: '/compras',
    name: 'Compras',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Store/Compras.vue')
    }
  },  
]

const router = new VueRouter({
  routes
})

export default router
